<ng-container *transloco="let t; prefix: 'shared.checkout'">
    <div class="border p-4 rounded-lg text-black mb-6" *ngFor="let product of selectedProducts" [ngClass]="{
        'billing-': product?.sku === '0001',
        'billing-photography': product?.sku === '0006',
        'billing-exclusive': product?.sku === '0005',
    }">
        <button (click)="toggleContent(product?.title || '')"
        class="flex flex-row items-center justify-between w-full"
        [ngClass]="{ 'mb-5': isContentDisplayed(product?.title || '') }">
        {{product?.title}}
        <i [ngClass]="{
            'icon-chevron-up': !isContentDisplayed(product?.title ?? ''),
            'icon-chevron-down': isContentDisplayed(product?.title ?? '')
            }"></i>
        </button>
        <div *ngIf="isContentDisplayed(product?.title ?? '')" [innerHtml]="product.benefits"></div>
    </div>
    <div class="p-4 bg-white rounded text-black font-semibold text-xl flex flex-row items-center justify-between mb-4" *ngFor="let product of selectedProducts">
        {{ t(getPricingDescription(product.sku || ''))}}
        <div class="flex flex-row items-center justify-between">
            <span *ngIf="(product?.discount || 0) > 0" class="font-normal line-through text-[#7E8797] mr-3">
                {{ product?.unitPrice | number }} €
            </span>
            <span class="text-secondary-900">
                {{ getFinalProductPrice(product?.unitPrice || 0, product?.discount || 0) | number }} €
            </span>
        </div>
    </div>
    <div class="divider-line1"></div>
    <div class="flex flex-row items-center justify-end mr-4 ">
        {{t('package.totalPrice')}}:&nbsp;
        <div class="flex flex-row items-center justify-end gap-3">
            <span *ngIf="displayTotalDiscount(selectedProducts)" class="font-normal line-through ">
                {{getTotalAmount(selectedProducts ?? []) | number }} €
            </span>
            <span class="text-secondary font-semibold text-xl">{{getTotalAmountWithDiscounts(selectedProducts ?? []) | number }} €</span>
        </div>
    </div>
</ng-container>